
// Add project specific javascript code here:
import {listItemActionRegistry,formToolbarActionRegistry,listToolbarActionRegistry} from 'sulu-admin-bundle/views';
import {ckeditorPluginRegistry, ckeditorConfigRegistry, fieldRegistry} from 'sulu-admin-bundle/containers';

// import DuplicateItemAction from "./listItemActions/DuplicateItemAction";
// listItemActionRegistry.add('mavu_global.duplicate', DuplicateItemAction);


import MavuSvelteField from "./my_fields/MavuSvelteField.js";
fieldRegistry.add('mavu_svelte_field', MavuSvelteField);

import "./my_app.css";

ckeditorConfigRegistry.add((config) => {
    return {
      heading: {
          options:  [
            {
                "model": "paragraph",
                "title": "Paragraph",
                "class": "ck-heading_paragraph"
            },
            {
                "model": "heading1",
                "view": "h1",
                "title": "Heading 1",
                "class": "ck-heading_heading1"
            },
            {
                "model": "heading2",
                "view": "h2",
                "title": "Heading 2",
                "class": "ck-heading_heading2"
            },
            {
                "model": "heading3",
                "view": "h3",
                "title": "Heading 3",
                "class": "ck-heading_heading3"
            },
            {
                "model": "heading4",
                "view": "h4",
                "title": "Heading 4",
                "class": "ck-heading_heading4"
            }
        ]
    },
    toolbar: [...config.toolbar,  '|', 'undo', 'redo'],
    };
});


(function (d) {
    // inject the global navigation
    const script = d.createElement('script');
    const script2 = d.createElement('script');
    const style = d.createElement('link');
    const head = d.querySelector('head');

    style.setAttribute('href', '/custom_assets/custom.css');
    style.setAttribute('rel', 'stylesheet');

    head.append(style);

    script.async=true;
    script.src='/custom_assets/custom.js';

    script.async=true;
    script2.src='/mavu_api/config.js';

    head.append(script);
    head.append(script2);
})(document)
